import jwtDecode from "jwt-decode";
import authjslib from "@/plugins/auth0jslib";
import appconfig from "@/appconfig";
import { store } from "@/store";

interface TokenDto {
  foo: string;
  exp: number;
  iat: number;
}

const routelib = {
  isValidToken() {
    const token = localStorage.getItem(appconfig.token);
    if (token) {
      const date = new Date(0);
      const decodedTokenPayload = jwtDecode<TokenDto>(token);
      date.setUTCSeconds(decodedTokenPayload.exp);
      return date.valueOf() > new Date().valueOf();
    }
    return false;
  },

  async getUserInfo() {
    await authjslib
      .userInfo(localStorage.getItem(appconfig.token))
      .then((profile: any) => {
        store.dispatch("setUserProfile", profile);
      });
  },

  isAuthorized(to: any) {
    const PrimaryContact = routelib.isPrimaryContact();
    if (
      to.matched.some(
        (record: { meta: { requiresPrimaryContact: any } }) =>
          record.meta.requiresPrimaryContact
      )
    ) {
      return routelib.isPrimaryContact();
    }
    return true;
  },

  isPrimaryContact() {
    const token = localStorage.getItem(appconfig.token);
    let isPrimaryContact = false;
    if (token) {
      //const decodedTokenPayload = jwtDecode(token);
      isPrimaryContact = jwtDecode<any>(token)[
        "https://www.bluetooth.com/claims/primaryContact"
      ];
    }
    return isPrimaryContact;
  },

  authguard(to: any, from: any, next: any) {
    if (
      to.matched.some(
        (record: { meta: { requiresAuth: any } }) => record.meta.requiresAuth
      )
    ) {
      if (routelib.isValidToken()) {
        routelib.getUserInfo();
        if (!routelib.isAuthorized(to)) {
          store.dispatch("setError", "accessDenied");
          const tovar = "membercontact/" + to.name + "/error";
          return next(tovar);
        }
        return next();
      } else {
        authjslib
          .checkSession()
          .then((authResult: any) => {
            localStorage.setItem(appconfig.token, authResult.accessToken);
            routelib.getUserInfo();
            return next();
          })
          .catch(err => {
            location.href = appconfig.loginurl + "?returnurl=" + location.href;
          });
      }
    } else return next();
  }
};

export default routelib;
